<template>
  <div class="img-add-group">
    <div class="btn-img-upload">
      <v-file-input
        label="File input w/ chips"
        chips
        multiple
        accept="image/png, image/jpeg"
        crossorigin="anonymous"
        @change="onChangeImg"
      >추가</v-file-input>
    </div>
    <div class="img-add-group">
      <div class="item" v-for="(item, i) in imgItems" :key="i">
        <v-btn @click="onClickPreview(item)">
          <img :src="item.src">
        </v-btn>
        <v-btn class="btn-img-del" @click="onClickDelete(item)"/>
      </div>
    </div>
  </div>
  <DialogImgView v-model="isShowDialog" @close="isShowDialog=false" :src="previewSrc"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';

const emit = defineEmits(['upload'])
const props = defineProps(['seq'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const isShowDialog = ref(false)
const imgItems = ref([])
const previewSrc = ref('')

//hook
onMounted(() => {
  let params = {
    monitoringIdx: viewIdx,
    isTemp:'Y',
    tempSeq: props.seq
  }

  TimelineService.getTimelineImageList(params).then(
    (response) => {
      if(response.result.length > 0){
        _.forEach(response.result, function(val, key) {
          const tempObj = {idx:val.idx, src:utils.getBaseUrl('timeline', val.filePath)}
          imgItems.value.push(tempObj)
        })
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
})

//function
function onChangeImg(e: Event){
  const files = (e.target as HTMLInputElement).files;
  if (!files || files.length === 0)
    return
  if(imgItems.value.length+files.length > 5){
    snackText.value = '최대 5개 입력가능합니다'
    snackbar.value = true
    return
  }

  for (let i = 0; i < files.length; i++) {
    const formData = new FormData()
    formData.append("file", files[i]);
    formData.append("monitoringIdx", viewIdx);
    formData.append("isTemp", "Y");
    formData.append("tempSeq", props.seq);
    formData.append('companyIdx', localStorage.getItem('companyIdx'));
    //const tempObj = {idx:i, src:URL.createObjectURL(files[i])}

    TimelineService.insertTimelineImage(formData).then(
      (response) => {
        if(response.success) {
          const tempObj = {idx:response.result.idx, src:utils.getBaseUrl('timeline', response.result.filePath)}
          imgItems.value.push(tempObj)
          emit('upload', '')
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

function onClickPreview(item){
  previewSrc.value = item.src
  isShowDialog.value = true
}

const onClickDelete=async(item)=>{
  try {
    const response = await TimelineService.deleteTempTimelineImage({timelineImageIdx: item.idx})
    if(response.success)
      _.pull(imgItems.value, item)
  }
  catch(error){
    if (error.status == 403)
      utils.movePage('/login')
    else {
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

</script>


<style lang="scss">
.img-add-group{
  .btn-img-upload{
    .v-input{
      display:block;
      .v-input__prepend{
        margin:0;
        .v-icon{
          display:block;
          width:auto;
          padding:0 2rem;
          height:4rem;
          line-height:4rem;
          text-align:center;
          color:var(--color-white);
          background: var(--color-main);
          border-radius:.5rem;
          opacity:1;
          &:before{
            content:"+";
            font-size:1.5rem;
          }
        }
      }
      .v-field{
        .v-field__overlay,
        .v-field__loader,
        .v-label,
        .v-field__outline{
          display:none;
        }
        .v-chip{
          font-size:1.2rem
        }
      }
      .v-input__details{
        display:none;
      }
      .v-field__input{
        padding:.8rem 0;
        min-height:auto;
      }
      .v-input__control{
        //display: inline-block;
        display:none;
      }
      button.v-btn{
        display:block;
        width:5rem;
        height:5rem;
        line-height:5rem;
        text-align:center;
        color:var(--color-white);
        background: var(--color-gray4);
      }
    }
  }
  .img-add-group{
    display:flex;
    flex-wrap: wrap;
    .item{
      position:relative;
      width:12rem;
      height:8rem;
      overflow:hidden;
      margin-right:1rem;
      margin-top:1rem;
      background:#DEE2EA url("/src/assets/img/ico-img.svg") center no-repeat;
      *{
        object-fit: contain;
        width:12rem;
        height:8rem;
      }
      .v-btn{
        background:transparent;
        &.btn-img-del{
          display:block;
          position:absolute;
          top:0;
          right:0;
          width:2.4rem;
          height:2.4rem;
          min-width:auto;
          padding:0;
          box-shadow:none;
          background: url("/src/assets/img/ico-img-close.svg") center no-repeat;
          *{
            width:2.4rem;
            height:2.4rem;
          }
        }
      }
    }
  }
}
</style>
